/**
 * Ergonix Advertorial Landing Page JS
 * - Sticky CTA bar (IntersectionObserver)
 * - FAQ accordion
 * - Smooth scroll
 * - Scroll reveal
 */

(function () {
  'use strict';

  // ========================================
  // 1. STICKY CTA BAR
  // ========================================
  function initStickyCTA() {
    var stickyBar = document.querySelector('.adv-sticky-cta');
    var heroCtaTrigger = document.querySelector('.adv-hero__cta-wrap');

    if (!stickyBar || !heroCtaTrigger) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('visible');
          } else {
            stickyBar.classList.add('visible');
          }
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(heroCtaTrigger);
  }

  // ========================================
  // 2. FAQ ACCORDION
  // ========================================
  function initFAQ() {
    var faqItems = document.querySelectorAll('.adv-faq-item');

    faqItems.forEach(function (item) {
      var question = item.querySelector('.adv-faq-item__question');
      var answer = item.querySelector('.adv-faq-item__answer');

      if (!question || !answer) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('active');

        // Close all others
        faqItems.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('active');
            var otherAnswer = other.querySelector('.adv-faq-item__answer');
            if (otherAnswer) otherAnswer.style.maxHeight = '0';
            var otherBtn = other.querySelector('.adv-faq-item__question');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current
        if (isOpen) {
          item.classList.remove('active');
          answer.style.maxHeight = '0';
          question.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ========================================
  // 3. SMOOTH SCROLL
  // ========================================
  function initSmoothScroll() {
    var links = document.querySelectorAll('a[href^="#adv-"]');

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('href');
        var target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ========================================
  // 4. SCROLL REVEAL
  // ========================================
  function initScrollReveal() {
    var elements = document.querySelectorAll('.adv-reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // ========================================
  // INIT
  // ========================================
  function init() {
    initStickyCTA();
    initFAQ();
    initSmoothScroll();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
